import { Identifiable, Resource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveOrganizationalUnitSuccess(
  resource: Identifiable<Resource>,
  { resourceUuids }: Boundaries["removeOrganizationalUnit"]["success"],
): Identifiable<Resource> {
  return resourceUuids.includes(resource.uuid)
    ? { ...resource, organizationalUnit: null }
    : resource;
}

export { handleRemoveOrganizationalUnitSuccess };
